module.exports = __webpack_public_path__ + "static/media/detect-location.054d5431.svg";